import {
    createDataMapper,
    transformSourceToTargetKeys,
} from '@common/utils/query/dataMappers';
import { CLIP_KEYS } from '../constants';
import { BackendSearchClip, Clip, DEFAULT_CLIP } from '../types';
import { mergeWithDefault } from '@common/utils/mergeWithDefault';

export const mapSearchClipToFrontend = (raw: BackendSearchClip): Clip => {
    const transformed = mergeWithDefault(
        transformSourceToTargetKeys(raw, CLIP_KEYS),
        DEFAULT_CLIP,
    );

    return {
        ...transformed,
        id: transformed.id.replace('Annotation_', ''),
        collectionId: raw.attachedEditorialObjectParentId?.[0] || '',
    };
};

export const transformClip = createDataMapper<BackendSearchClip, Clip>(
    mapSearchClipToFrontend,
    true,
);
